import React from "react";
import ReactDOM from "react-dom";
import "./global.css";
import App from "./Routes/routes";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
